import RecaptchaLibProvider from '@/libs/recaptcha-lib/components/RecaptchaLibProvider';

function RecaptchaContainer({ children }: React.PropsWithChildren) {
  return (
    <RecaptchaLibProvider
      scoreBasedSiteKey={import.meta.env.VITE_RECAPTCHA_SCORE_BASED_SITE_KEY}
      checkboxFallbackSiteKey={import.meta.env.VITE_RECAPTCHA_CHECKBOX_FALLBACK_SITE_KEY}
    >
      {children}
    </RecaptchaLibProvider>
  );
}

export default RecaptchaContainer;
